import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const PILL_TONES = {
  green: { bg: '#E8F5E9', border: '#C8E6C9', dot: '#43A047', text: '#2E7D32' },
  blue: { bg: '#E3F2FD', border: '#BBDEFB', dot: '#1E88E5', text: '#1565C0' },
  orange: { bg: '#FFF3E0', border: '#FFE0B2', dot: '#FB8C00', text: '#E65100' },
  red: { bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  grey: { bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
};

/**
 * TrialOutreachPill - Etiqueta arredondada da tela Contato com testes
 * (mesmo desenho do SignupStatusChip de Cadastros pendentes).
 * @param {Object} props
 * @param {string} props.label
 * @param {'green'|'blue'|'orange'|'red'|'grey'} props.tone
 */
function TrialOutreachPill({ label, tone = 'grey' }) {
  const cfg = PILL_TONES[tone] || PILL_TONES.grey;
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        maxWidth: '100%',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1.3, color: cfg.text }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default TrialOutreachPill;
